import { render } from "./OptionalsCellRenderer.vue?vue&type=template&id=48e37de0&ts=true"
import script from "./OptionalsCellRenderer.vue?vue&type=script&lang=ts"
export * from "./OptionalsCellRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\victo\\Documents\\Projects\\RawData\\product-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__